import NotAvailable from './NotAvailable';

export default NotAvailable;
